import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { IMG_GRANT } from "@/lib/images";
import { HeartHandshake, Stethoscope, Users, PiggyBank, Sparkles } from "lucide-react";

const stats = [
  { icon: Users, value: "40", label: "Children served" },
  { icon: Users, value: "30", label: "Adults served" },
  { icon: PiggyBank, value: "$24,500+", label: "Saved in care" },
];

export default function GrantAppreciation() {
  return (
    <div className="App">
      <Navbar />

      {/* Banner */}
      <section className="pt-28 bg-[#6B4C8A]">
        <div className="max-w-5xl mx-auto px-6 py-16 text-center">
          <p className="label text-sm uppercase tracking-[0.2em] text-[#E5DEEB] font-semibold">With Gratitude</p>
          <h1 className="font-serif text-4xl sm:text-5xl text-white mt-3">Grant Appreciation</h1>
          <p className="text-lg text-[#EDE7F2] mt-4 max-w-2xl mx-auto">
            Honoring the partners whose generosity makes our mobile mission possible.
          </p>
          <div className="mt-8 inline-block bg-white rounded-2xl shadow-lg px-10 py-6">
            <img src={IMG_GRANT} alt="The Catholic Foundation — Archdiocese of Santa Fe" className="h-16 w-auto mx-auto object-contain" data-testid="grant-banner-image" />
          </div>
        </div>
      </section>

      {/* Body */}
      <section className="max-w-4xl mx-auto px-6 py-20">
        <div className="flex items-center gap-3">
          <HeartHandshake className="h-8 w-8 text-[#6B4C8A]" />
          <h2 className="font-serif text-3xl text-[#2D2336]">Thank You to The Catholic Foundation</h2>
        </div>
        <p className="text-lg text-[#5C5166] leading-relaxed mt-6">
          Utopia Dental Care extends its deepest gratitude to <strong>The Catholic Foundation,
          Archdiocese of Santa Fe</strong>, for the generous grant awarded in <strong>2025</strong>.
          This vital support allowed <strong>Utopia Mobile Care</strong> to extend compassionate,
          high-quality dental care to significantly more patients across New Mexico — especially
          those who are underinsured or without any dental coverage.
        </p>
        <p className="text-lg text-[#5C5166] leading-relaxed mt-5">
          Thanks to this funding, our team was able to purchase essential clinical equipment and
          expand the capacity of our mobile units. These investments strengthened our ability to
          deliver preventive and restorative care — from diagnostic radiographs and prophylaxis to
          periodontal therapy — directly within the communities we serve, reducing barriers to
          access and advancing long-term oral health outcomes for vulnerable populations.
        </p>

        {/* Highlighted impact statement */}
        <div className="mt-10 bg-[#F3EFF7] border-l-4 border-[#6B4C8A] rounded-r-2xl p-8" data-testid="grant-impact-statement">
          <Sparkles className="h-7 w-7 text-[#6B4C8A]" />
          <p className="text-[#2D2336] leading-relaxed mt-3 text-lg italic">
            “The impact of our project saved out of pocket costs, travel, and benefited the oral
            health of those in need. A total of forty children and thirty adults have been receiving
            individual and ongoing service with oral education, teeth cleaning, x-rays, and deep
            cleaning. Students and Parish members received complete care and mobile services saving
            over $24,500.”
          </p>
        </div>

        {/* Stats */}
        <div className="grid sm:grid-cols-3 gap-6 mt-12" data-testid="grant-stats">
          {stats.map((s, i) => (
            <div key={i} className="bg-white border border-[#E5DEEB] rounded-2xl p-8 text-center shadow-sm">
              <s.icon className="h-8 w-8 text-[#6B4C8A] mx-auto" />
              <p className="font-serif text-4xl text-[#2D2336] mt-4">{s.value}</p>
              <p className="text-sm text-[#78698A] mt-1">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex items-start gap-3 bg-white border border-[#E5DEEB] rounded-2xl p-8">
          <Stethoscope className="h-7 w-7 text-[#6B4C8A] shrink-0" />
          <p className="text-[#5C5166] leading-relaxed">
            Every cleaning, x-ray, and deep cleaning provided through this initiative reflects our
            shared commitment to whole-community wellness. With The Catholic Foundation as a partner,
            Utopia Mobile Care continues expanding services to the underserved pediatric and elderly
            populations of New Mexico — one healthy smile at a time.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
